module.exports = __webpack_public_path__ + "static/media/VIRTUAL_COURSE_SMALL.fd4fd790.jpg";